<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-reg"
          routerLink="/marketing/social/contentRequests"
          >Content Requests
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          routerLink="/marketing/social/registry"
          >Social Registry
        </a>
      </div>
    </div>
  </div> -->

    <div class="row mb-4 mt-2 text-center">
      <div class="col-12">
        <div class="platform-cards-container">
          <!-- Instagram -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'instagram' }"
            (click)="applyFilters()"
          >
            <!-- (click)=" filters.platform =
                filters.platform === 'instagram' ? '' : 'instagram'; -->
            <div class="platform-icon ig">
              <i class="fab fa-instagram"></i>
            </div>
            <span class="platform-name">Instagram</span>
          </div>

          <!-- Facebook -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'facebook' }"
            (click)="applyFilters()"
          >
            <!-- (click)="
              filters.platform =
                filters.platform === 'facebook' ? '' : 'facebook';
            " -->
            <div class="platform-icon fb">
              <i class="fab fa-facebook-f"></i>
            </div>
            <span class="platform-name">Facebook</span>
          </div>

          <!-- YouTube -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'youtube' }"
            (click)="applyFilters()"
          >
            <!-- (click)="
              filters.platform =
                filters.platform === 'youtube' ? '' : 'youtube';
            " -->
            <div class="platform-icon yt">
              <i class="fab fa-youtube"></i>
            </div>
            <span class="platform-name">YouTube</span>
          </div>

          <!-- TikTok -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'tiktok' }"
            (click)="applyFilters()"
          >
            <!-- (click)="
              filters.platform = filters.platform === 'tiktok' ? '' : 'tiktok';
            " -->
            <div class="platform-icon tt">
              <i class="fab fa-tiktok"></i>
            </div>
            <span class="platform-name">TikTok</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3 mt-4">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/strategy"
            >STRATEGY
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/semantika"
            >SEMANTIKA
          </a>
          <!-- <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/performance"
            >PERFORMANCE
          </a> -->
          <a class="btn btn-dark btn-sm btn-new">NOTES </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/mediaroom/social"
            >MEDIAROOM
          </a>
        </div>
      </div>
    </div>

    <div class="intake-container p-4" *ngIf="!loading">
      <!-- Header -->
      <div class="mb-4">
        <h2 class="mb-1 fw-bold" style="color: #0b1c3c">
          MediaRoom Request Intake
        </h2>
        <div class="text-secondary mb-2" style="font-size: 13px; text-transform: uppercase;">
          INITIATOR &rarr; MediaRoom Handoff
        </div>
        <p class="text-dark small mb-0">
          Constituted Initiatives received from INITIATOR. Each Initiative is individually identified.
        </p>
      </div>

      <!-- Top Info Card -->
      <div class="card shadow-sm mb-4 bg-white" style="border-radius: 8px; border: 1px solid #eaeaea">
        <div class="card-body p-0">
          <div class="row g-0">
            <!-- Col 1 -->
            <div class="col-md-6 d-flex align-items-center p-3 border-end border-muted border-right position-relative">
              <div class="mr-3 ml-3 d-flex align-items-center justify-content-center" style="width: 45px; height: 45px; background-color: #f0f4ff; border-radius: 8px; color: #3b82f6;">
                <i class="fas fa-box" style="font-size: 20px"></i>
              </div>
              <div>
                <div class="text-dark small mb-1">Constituting Entity</div>
                <div class="fw-bold" style="color: #3b82f6">
                  INITIATOR
                </div>
              </div>
            </div>
            <!-- Col 2 -->
            <div class="col-md-6 d-flex align-items-center p-3">
              <div class="mr-3 d-flex align-items-center justify-content-center" style="width: 45px; height: 45px; background-color: #f0f4ff; border-radius: 8px; color: #3b82f6;">
                <i class="far fa-calendar-alt" style="font-size: 20px"></i>
              </div>
              <div>
                <div class="text-dark small mb-1">Handoff Type</div>
                <div class="fw-bold" style="color: #3b82f6">
                  Weekly Block Cohort
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Table Section -->
      <div class="card shadow-sm mb-4 bg-white" style="border-radius: 8px; border: 1px solid #eaeaea">
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table align-middle mb-0">
              <thead class="bg-light text-uppercase">
                <tr>
                  <th class="border-bottom-0" style="width: 50px;"></th>
                  <th class="text-dark small fw-bold border-bottom-0 py-3 header-table text-transform-none">Order ID <i class="fas fa-info-circle text-muted ms-1"></i></th>
                  <th class="text-dark small fw-bold border-bottom-0 py-3 header-table text-transform-none">Platform <i class="fas fa-info-circle text-muted ms-1"></i></th>
                  <th class="text-dark small fw-bold border-bottom-0 py-3 header-table text-transform-none">Surface <i class="fas fa-info-circle text-muted ms-1"></i></th>
                  <th class="text-dark small fw-bold border-bottom-0 py-3 text-center header-table text-transform-none">Category <i class="fas fa-info-circle text-muted ms-1"></i></th>
                  <th class="text-dark small fw-bold border-bottom-0 py-3 header-table text-transform-none">Objective <i class="fas fa-info-circle text-muted ms-1"></i></th>
                  <th class="text-dark small fw-bold border-bottom-0 py-3 header-table text-transform-none">Status <i class="fas fa-info-circle text-muted ms-1"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of initiativesList; let last = last" [class.border-bottom]="!last">
                  <td class="text-dark small text-center ps-4 py-3 ">{{ item.id }}</td>
                  <td class="small py-3 text-nowrap">
                    <a href="#" class="text-primary text-decoration-none fw-medium">{{ item.orderId }}</a>
                  </td>
                  <td class="text-dark small py-3 text-nowrap">
                    <i [class]="item.platformIcon + ' mr-2'" style="font-size: 16px;"></i> {{ item.platform }}
                  </td>
                  <td class="text-dark small py-3">{{ item.surface }}</td>
                  <td class="text-center py-3">
                    <span class="badge text-transform-none" style="background-color: #f0f4ff; color: #5c6bc0; font-weight: 500; font-size: 12px; padding: 6px 12px; border-radius: 6px;">
                      {{ item.category }}
                    </span>
                  </td>
                  <td class="text-dark small py-3">{{ item.objective }}</td>
                  <td class="small py-3 text-nowrap">
                    <i class="far fa-check-circle text-success mr-2" style="font-size: 16px;"></i> <span class="text-dark">{{ item.status }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Focus Notes Section -->
      <div class="card shadow-sm mb-4 bg-white" style="border-radius: 8px; border: 1px solid #eaeaea">
        <div class="card-body p-4">
          <h4 class="fw-bold text-dark mb-2"><strong>Focus Notes</strong></h4>
          <p class="text-dark small mb-0" [innerHTML]="intakeInfo.focusNotes"></p>
        </div>
      </div>

      <!-- Footer Summary Section -->
      <div class="card shadow-sm mb-4" style="background-color: #f8fafc; border-radius: 8px; border: 1px solid #eaeaea">
        <div class="card-body py-4 px-2 d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <div class="mr-2 d-flex align-items-center justify-content-center" style="width: 35px; height: 35px; background-color: #4CAF50; border-radius: 50%; color: white;">
              <i class="fas fa-check" style="font-size: 20px;"></i>
            </div>
            <div>
              <div class="d-flex align-items-center gap-4">
                <h4 class="fw-bold mb-0 text-nowrap" style="color: #2e7d32; margin-right: 20px;">Handoff Complete</h4>
                <p class="text-dark small mb-0 fw-medium">All 8 expected Initiatives have been received successfully.</p>
              </div>
            </div>
          </div>
          
          <div class="d-flex gx-4 text-center">
            <div class="px-4 border-end border-muted border-right">
              <div class="text-dark small mb-1" style="font-size: 11px;">Expected</div>
              <div class="fw-bold text-dark fs-5">8</div>
            </div>
            <div class="px-4 border-end border-muted border-right">
              <div class="text-dark small mb-1" style="font-size: 11px;">Received</div>
              <div class="fw-bold text-dark fs-5">8</div>
            </div>
            <div class="px-4 border-end border-muted border-right">
              <div class="text-dark small mb-1" style="font-size: 11px;">Pending</div>
              <div class="fw-bold text-dark fs-5">0</div>
            </div>
            <div class="pl-4">
              <div class="text-dark small mb-1" style="font-size: 11px;">Rejected</div>
              <div class="fw-bold text-dark fs-5">0</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
